import { ACE_BLOCKCHAINS } from '@services/static-data/blockchains'

/**
 * Map of supported chains to USDC contract addresses.
 */
export const CHAIN_IDS_TO_USDC_ADDRESSES = ACE_BLOCKCHAINS.reduce<
  Record<number, string>
>((acc, b) => {
  if (b.chainId != null && b.usdcAddress?.live != null) {
    acc[b.chainId] = b.usdcAddress.live
  }

  if (b.testnetChainId != null && b.usdcAddress?.test != null) {
    acc[b.testnetChainId] = b.usdcAddress.test
  }

  return acc
}, {})

/**
 * Map of supported chains to Token Messenger contract addresses.
 */
export const CHAIN_IDS_TO_TOKEN_MESSENGER_ADDRESSES = ACE_BLOCKCHAINS.reduce<
  Record<number, string>
>((acc, b) => {
  if (b.chainId != null && b.tokenMessengerAddress?.live != null) {
    acc[b.chainId] = b.tokenMessengerAddress.live
  }

  if (b.testnetChainId != null && b.tokenMessengerAddress?.test != null) {
    acc[b.testnetChainId] = b.tokenMessengerAddress.test
  }

  return acc
}, {})

/**
 * Map of supported chains to Message Transmitter contract addresses.
 */
export const CHAIN_IDS_TO_MESSAGE_TRANSMITTER_ADDRESSES =
  ACE_BLOCKCHAINS.reduce<Record<number, string>>((acc, b) => {
    if (b.chainId != null && b.messageTransmitterAddress?.live != null) {
      acc[b.chainId] = b.messageTransmitterAddress.live
    }

    if (b.testnetChainId != null && b.messageTransmitterAddress?.test != null) {
      acc[b.testnetChainId] = b.messageTransmitterAddress.test
    }

    return acc
  }, {})
